import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { HStack } from '../layouts/stack.layout';
import Button from '../button/v2/button';
import Text from '../typography/v2/text';

import { PATH } from '../../constants';
import { bookmarkThemeOptions } from './themeOptions/bookmark-theme.option';

const readable = {
  ADD: 'added to you',
  REMOVE: 'removed from your',
};

const textColorFor: { dark: 'primary'; light: 'base' } = {
  dark: 'primary',
  light: 'base',
};

export const bookmarkToast = (
  feedType: 'Article' | 'Post',
  action: 'ADD' | 'REMOVE'
) => {
  const message = `${feedType} ${readable[action]} your Bookmarks`;
  toast(
    <HStack
      extensions="items-center"
      justify={action === 'ADD' ? 'between' : 'center'}
    >
      <Text color={textColorFor['dark']}>{message}</Text>
      {action === 'ADD' && (
        <Link to={`/${PATH.BOOKMARKS}`}>
          <Button color={textColorFor['dark']} variant="text">
            View
          </Button>
        </Link>
      )}
    </HStack>,
    bookmarkThemeOptions('dark')
  );
};
